module.exports = __webpack_public_path__ + "img/left-box-en.00f9ec02.png";